import { DRIVE_KEYS_PAGE_SIZE } from "services/orchid-drive/getDriveKeys";
import getDriveFiles from "services/orchid-drive/getDriveFiles";
import { calculateChunkCount } from "utils/calculateChunkCount";

export async function getEntryMetadata(entryIds: string[]) {
  const combinedResults: {
    files: Record<string, OrchidDriveFileNotify>;
    directories: Record<string, OrchidDriveDirectoryNotify>;
  } = {
    files: {},
    directories: {},
  };
  const chunkCount = calculateChunkCount(entryIds.length, DRIVE_KEYS_PAGE_SIZE);
  for (let chunkNum = 0; chunkNum < chunkCount; ++chunkNum) {
    const idsChunk = entryIds.slice(
      chunkNum * DRIVE_KEYS_PAGE_SIZE,
      (chunkNum + 1) * DRIVE_KEYS_PAGE_SIZE,
    );
    const result = await getDriveFiles({ entry_ids: idsChunk });

    ["files", "directories"].forEach((k) => {
      result[k].forEach((entry) => {
        combinedResults[k][
          entry[k === "files" ? "file_data_id" : "directory_id"]
        ] = entry;
      });
    });
  }
  return combinedResults;
}
